import React from 'react';
import { getFormData, updateFormData } from '../../../utils/pip';
import { Formik } from 'formik';
import { step1Schema } from '../../../utils/schema';
import ErrorMessage from '../../form/ErrorMessage';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';


const CoachSignUpStep1Modal = ({ stepBack, setSignupStep, onClose, backToLogin }) => {
    const savedData = getFormData().step1;

    const handleStep1 = (values) => {
        updateFormData("step1", values);
        setSignupStep()
    };

    return (
        <div
            className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
            tabIndex="-1"
        >
            <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
                <div class="modal-content">
                    <div class="modal-header border-0 p-0 pb-2">
                        <button
                            type="button"
                            class="btn-close ct_close_position_right12"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div class="modal-body pe-0">
                        <section class="ct_signup_main py-3">
                            <div class="container-fluid">
                                <div class="row align-items-center">
                                    <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                                        <div class="ct_signup_left_img">
                                            <img
                                                src="../assets/img/coach_signup_img.png"
                                                alt=""
                                                style={{ objectFit: "cover" }}
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
                                        <div class="ct_signup_right_content px-5 ct_custom_scroll">
                                            <div
                                                className="ct_back_top_btn"
                                                onClick={stepBack}
                                            >
                                                <i class="fa-solid fa-arrow-left"></i>
                                            </div>
                                            <div class="ct_signup_logo ct_mb_34">
                                                <img src="../assets/img/Nuvio_logo.png" alt="" />
                                            </div>
                                            <div class="mt-0 text-center">
                                                <h2 class="ct_fs_32  mb-0">
                                                    Hi! Begin Coaching with{" "}
                                                    <span class="ct_yellow_text">Nuvio</span>
                                                </h2>
                                            </div>
                                            <Formik
                                                initialValues={savedData}
                                                validationSchema={step1Schema}
                                                onSubmit={(values, actions) => {
                                                    handleStep1(values);
                                                }}
                                            >
                                                {({
                                                    values,
                                                    errors,
                                                    touched,
                                                    handleChange,
                                                    handleBlur,
                                                    handleSubmit,
                                                    setFieldValue,
                                                    setFieldError,
                                                }) => (
                                                    <form onSubmit={handleSubmit} class="mt-5">
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                                <div class="form-group mb-4">
                                                                    <label for="" class="mb-2 d-block ct_darkblue_text">
                                                                        Full Name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control ct_input"
                                                                        placeholder="Full Name"
                                                                        id="full_name"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values?.full_name}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="full_name"
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div class="col-md-6">
                                                                <div class="form-group mb-4">
                                                                    <label for="" class="mb-2 d-block ct_darkblue_text">
                                                                        Email
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control ct_input"
                                                                        placeholder="Email"
                                                                        id="email"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values?.email}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="email"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-4">
                                                                    <label for="" class="mb-2 d-block ct_darkblue_text">
                                                                        Phone Number{" "}
                                                                    </label>
                                                                    <PhoneInput
                                                                        id="phone_number"
                                                                        className="form-control ct_input ct_input_grey_border_1 ct_border_radius_5 ct_h_44"
                                                                        defaultCountry="MU"
                                                                        value={values?.phone_number}
                                                                        onChange={(val) => {
                                                                            const safeVal = val ?? "";
                                                                            if (
                                                                                typeof safeVal === "string" &&
                                                                                safeVal.length > 2 &&
                                                                                isValidPhoneNumber(safeVal)
                                                                            ) {
                                                                                setFieldValue("phone_number", safeVal);
                                                                            } else if (!isValidPhoneNumber(safeVal)) {
                                                                                setFieldError(
                                                                                    "phone_number",
                                                                                    "Please enter valid phone number"
                                                                                );
                                                                                setFieldValue("phone_number", safeVal);
                                                                            }
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="phone_number"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="text-center mt-2">
                                                            <button
                                                                type="submit"
                                                                // onClick={(e) => goTo(e, coachPaths.CoachSignUpStep2)}
                                                                onClick={handleSubmit}
                                                                class="ct_yellow_btn w-75 mx-auto"
                                                            >
                                                                Continue
                                                            </button>
                                                        </div>
                                                    </form>
                                                )}
                                            </Formik>
                                            <div class=" text-center mt-4 ct_darkblue_text">
                                                Already have an account?{" "}
                                                <a
                                                    class="ct_orange_text"
                                                    onClick={backToLogin}
                                                >
                                                    Sign In
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CoachSignUpStep1Modal;